exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".languageOptions{position:absolute;right:0;top:0;margin:16px}.languageOption{height:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/Language/styles.sass
// module id = 117
// module chunks = 0